import { getOnePieceServerApi } from 'gql-ops';
import { useEffect } from 'react';
import application from 'stores/application';
import contracts from 'stores/contracts';
import simpleDialog from 'stores/simpleDialog';
import user from 'stores/user';

export default function useGetContractByGraph() {
    async function getGlobal() {
        try {
            console.log('Fetching global info from GraphQL...');
            const res = await getOnePieceServerApi().global();
            console.log('GraphQL response:', res);
            if (res?.global) {
                console.log('Setting capsule contract with:', {
                    address: res.global.capsuleNFT.contractAddress,
                    hasABI: !!res.global.capsuleNFT.abi,
                    chainId: user.chainId,
                });
                contracts.setCapsuleContract(res.global.capsuleNFT.contractAddress, res.global.capsuleNFT.abi);
                application.setNftCount(Number(res.global.capsuleNFT.mintedCount));
                application.setGlobalStats(res.global);

                // application.setGec(new BigNumber(res.global.gec).shiftedBy(-18).toNumber());
            } else {
                console.error('Global info is missing or invalid:', res);
            }
        } catch (e) {
            console.error('Error fetching global info:', e);
            simpleDialog.error({
                title: 'Error',
                text: 'There are some issues with your internet connection, please check and try again later.',
            });
        }
    }

    useEffect(() => {
        getGlobal();
    }, []);

    return null;
}
